export class AgencyModel {
    agencyId: number;
    agencyName: string;
}